<script setup>
import { useBg } from '@/stores/bgStore';
import { useIntersectionObserver } from '@vueuse/core';
import FormContact from '../Form/FormContact.vue';
import { ref } from 'vue';
const props = defineProps({
    text: String,
});

const bg = useBg();
const target = ref(null);
useIntersectionObserver(target, ([{ isIntersecting }], observerElement) => {
    isIntersecting ? bg.add('contact-form') : bg.remove('contact-form');
});
</script>

<template>
    <div ref="target">
        <div class="container gap-16 my-15 md:flex md:my-30">
            <div class="md:w-4/12">
                <div v-if="text" v-html="text" class="max-w-full mb-8 prose text-primary marker:text-primary"></div>
            </div>
            <div class="md:w-8/12">
                <FormContact />
            </div>
        </div>
    </div>
</template>
